export default "__VITE_ASSET__c01402dd__"